import api from "@/config/api";

const path = "public/formular/employee/checkin"

export default {

  get: (token) => {
    return api.get(path, { params: { token } })
  },
  post: (checkin, token) => {
    return api.post(path, checkin, { params: { token } })
  }
}
